import {useState, useCallback} from 'react'

// Component
import SearchComponent from './Search.component'

// HOCs
import {withHooks} from '~/hocs'

const useHooks = () => {
  const [value, setValue] = useState('')

  const handleInputChange = useCallback((e) => {
    setValue(e.target.value)
  }, [setValue])

  const handleSearch = useCallback((e) => {
    e.preventDefault()
  }, [])

  return {
    value,
    handleInputChange,
    handleSearch,
  }
}

const SearchContainer = withHooks(useHooks)(SearchComponent)

export default SearchContainer
